import React, { useState } from 'react';
import { Form as FinalForm } from 'react-final-form';
import { BusinessUnit } from '@zola-helpers/client/dist/es/@types';
import detectBusinessUnit from '@zola-helpers/client/dist/es/util/detectBusinessUnit';

import FormInput from '../../../Form/InputFieldV2/FormInput';
import { ButtonV3 } from '../../../ButtonV3';
import { LinkV2 } from '../../../LinkV2';
import ForgotPasswordSuccess from '../ForgotPasswordSuccess';

import useAuthErrorHandler from '../../../../hooks/useAuthErrorHandler';
import * as Validations from '../../../Form/util/validations';
import { sendResetPassword } from '../../../../actions/AuthActions';
import { AuthState } from '../../types';

import containerStyles from '../../AuthForms.module.less';

type ForgotPasswordFormProps = {
  setAuthState: (type: AuthState) => void;
  onClickSignup: () => void;
};

const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = ({ setAuthState, onClickSignup }) => {
  const [view, setView] = useState<'password' | 'success'>('password');
  const [errorMessage, handleError] = useAuthErrorHandler();

  const onSubmit = ({ email }: { email: string }) =>
    sendResetPassword(email)
      .then(() => setView('success'))
      .catch(handleError);

  if (view === 'success') {
    return <ForgotPasswordSuccess />;
  }

  return (
    <FinalForm onSubmit={onSubmit}>
      {({ handleSubmit, submitting }) => (
        <>
          <h1 className={containerStyles.title}>Forgot password</h1>
          <p className={containerStyles.textCenter}>
            Enter your email address and we&#39;ll send you a link to change your password.
          </p>
          <form data-testid="zui-forgot" onSubmit={handleSubmit}>
            <FormInput
              className={containerStyles.field}
              name="email"
              type="email"
              label="Email"
              id="zui-forgot__email"
              data-testid="zui-forgot__email"
              required
              validate={[Validations.REQUIRED, Validations.EMAIL]}
            />
            <ButtonV3
              disabled={submitting}
              fullWidth
              type="submit"
              className={containerStyles.submit}
              size="large"
            >
              Submit
            </ButtonV3>
          </form>
          {errorMessage && (
            <div className={containerStyles.error}>
              {errorMessage ||
                'There was a problem processing your request. Please try again or contact customer support for assistance.'}
            </div>
          )}
          <div className={containerStyles.textCenter}>
            <LinkV2
              role="button"
              noTextTransform
              onClick={() => setAuthState(AuthState.LOGIN)}
              sizes="smaller"
            >
              Log in
            </LinkV2>{' '}
            /{' '}
            <LinkV2 role="button" noTextTransform onClick={onClickSignup} sizes="smaller">
              {detectBusinessUnit() === BusinessUnit.STORE ? 'Create account' : 'Sign up'}
            </LinkV2>
          </div>
        </>
      )}
    </FinalForm>
  );
};

export default ForgotPasswordForm;
